import React from 'react';
import './Loader.css';
import Lottie from 'lottie-react';
import loadingAnimation from "../../../public/Loading.json";
import { useIntl } from 'react-intl';

const Loader = () => {
  const intl = useIntl();
  return (
    <div className="loader-overlay">
      <div className="lottie-loader">
        <Lottie
          animationData={loadingAnimation}
          loop={true}
          style={{ width: 110, height: 110 }}
        />
        <span className='loader-text'>{intl.formatMessage({ id: "loadingText" })}</span>
      </div>
    </div>
  );
};

export default Loader; 